<template>
    <div class="container2">
        <header>
            <div class="row d-flex align-items-center justify-content-center">
                <div
                    class="text-center col-md-8 col-12 col-sm-12 col-xl-8"
                    id="header1"
                >
                    <h1>Bienvenue dans le BPI du CRIms</h1>
                    <h6>
                        Vous pouvez créer, modifier et générer <br />
                        votre Business Plan en quelques minutes
                    </h6>
                </div>
            </div>

            <div class="row d-flex align-items-center justify-content-center">
                <div
                    class="pt-3 text-center col-md-8 col-12 col-sm-12 col-xl-8"
                >
                    <p class="text-left">
                        L’élaboration d’un business plan nécessite un minimum de
                        savoir-faire, tant dans sa forme que dans son fond. Le
                        CRIms vous offre un outil d’aide et d’accompagnement dans
                        la création de votre Business Plan de manière
                        interactive, en vous offrant en plus, des données
                        fiables, concernant l’investissement dans la Région de
                        Marrakech-Safi.
                    </p>

                    <article
                        class="text-left"
                        data-title="Economiseur de temps et d’argent"
                    >
                        <h3>Economiseur de temps et d’argent :</h3>

                        <p class="text-left">
                            L’application BPI offerte aux investisseurs par le
                            CRIms, permet l’élaboration d’un business plan dans
                            un temps optimal et sans payer les frais de ce
                            service. Il vous suffit d’être inscrit à
                            l’application via l’Observatoire de l’investissement
                            de la Région  Marrakech-Safi, accessible depuis le
                            site web du CRIms pour les professionnels.
                        </p>
                    </article>
                </div>
            </div>
        </header>

        <section data-page="prerequis-inscription">
            <div class="row d-flex align-items-center justify-content-center">
                <div class="text-center col-md-8 col-12 col-sm-12 col-xl-8">
                    <article class="text-left">
                        <h2>Rédigez votre BP, avec un peu d’aide</h2>

                        <p>
                            Le BPI vous permet de saisir les informations
                            concernant les investisseurs et le projet et offre
                            une multitude d’informations techniques facilitant
                            l’élaboration d’un business plan. Parmis ces
                            informations on compte des centaines d’études
                            séctorielles, l’offre foncière de la Région de
                            Marrakech-Safi, les couts des facteurs de production et
                            tant d’autres. Ce guide vous permet d’avoir un
                            aperçu sur l’ensemble de l’application, son
                            prerequis et comment l’utiliser.
                        </p>
                    </article>

                    <article class="text-left">
                        <h2>
                            Prérequis : Les informations dont vous aurez <br />
                            besoin pour la création de votre BP
                        </h2>

                        <p>
                            Avant de commencer votre saisie et afin d’optimiser
                            le processus d’élaboration de votre business plan.
                            Il est préferable de vous munir des informations
                            suivantes avant de commencer la saisie dans la
                            plateforme du BPI :
                        </p>
                        <ul>
                            <li>
                                Vos besoins en formation : Réaliser une petite
                                analyse pour savoir quelles sont vos besoins en
                                terme de formation.
                            </li>
                            <li>
                                Les informations concernant votre entreprise, si
                                elle est déjà créée. Le secteur dans lequel vous
                                compter lancer votre activité, ainsi qu’un
                                minimum d’informations sur vos produits ou
                                services.
                            </li>
                            <li>
                                Un minimum d’informations sur vos produits ou
                                services.
                            </li>
                            <li>
                                Des photos aux format numérique, de vos moyens
                                fonciers et immeubles, ainsi qu’un minimum
                                d’informations sur ceux-ci.
                            </li>
                            <li>
                                Les devis ou les factures, ou bien des
                                estimations pour l’ensemble des acquisitions ou
                                travaux que vous souhaiter réaliser pour votre
                                projet.
                            </li>
                            <li>
                                La simulation de votre crédit leasing auprès de
                                votre banquier, si vous comptez utiliser cette
                                solution de financement pour l’un de vos
                                investissement.
                            </li>
                            <li>
                                Vos taxes et impôts : Taxe professionnelle,
                                impôt sur le revenu si il est applicable ainsi
                                que d’autres taxes. Cependant la taxe de
                                services communaux est calculé automatiquement
                                par la plateforme.
                            </li>
                            <li>
                                Il est à noter que tout les montants saises sont
                                considérés comme hors taxe (HT) par le système.
                            </li>
                        </ul>
                    </article>
                </div>
            </div>
        </section>

        <section data-page="guide-inscription">
            <div class="row d-flex align-items-center justify-content-center">
                <div class="col-md-8 col-12 col-sm-12 col-xl-8">
                    <div class="mt-5">
                        <h2>
                            Inscrivez-vous et saisissez vos <br />
                            informations et celles de vos associés
                        </h2>

                        <figure>
                            <figcaption>
                                Inscrivez-vous, ou connectez-vous si voue etes
                                déjà inscrit :
                            </figcaption>
                            <img
                                src="/img/Img1.png"
                                alt="Trulli"
                                style="width:100%"
                            />
                            <img
                                src="/img/Img2.png"
                                alt="Trulli"
                                style="width:100%"
                            />
                        </figure>
                    </div>

                    <figure>
                        <figcaption>
                            Puis choisir, la version la mieux adaptée à votre
                            activité, simplifiée ou détaillée, selon le volume
                            de votre chiffre d’affaire :
                        </figcaption>
                        <img
                            src="/img/Img3.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                    </figure>

                    <figure>
                        <figcaption>
                            Vous serez inviter ensuite à saisir les informations
                            relatives aux investisseurs de votre projet :
                        </figcaption>
                        <img
                            src="/img/Img4.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                        <figcaption>
                            Vous pouvez ajouter tant d’investisseurs que vous
                            voulez !
                        </figcaption>
                    </figure>

                    <div class="mt-5">
                        <h2>
                            Saisissez les informations relatives à votre projet
                        </h2>
                        <figure>
                            <figcaption>
                                Saisir d’abord les inoformations sur votre
                                entreprise :
                            </figcaption>
                            <img
                                src="/img/Img6.png"
                                alt="Trulli"
                                style="width:100%"
                            />
                        </figure>
                    </div>

                    <figure>
                        <figcaption>
                            Ensuite celles de votre projet :
                        </figcaption>
                        <img
                            src="/img/Img7.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                        <figcaption>
                            <b>NB :</b> Pour la zone de texte « Description du
                            projet » veuillez répondre aux questions présentes
                            dans la zone de saisie afin de vous aider dans la
                            rédaction de la description de votre projet, qui
                            sera ensuite reprise dans l’executive summary de
                            votre business plan.
                        </figcaption>
                    </figure>

                    <figure>
                        <figcaption>
                            Puis, vos produits ou services :
                        </figcaption>
                        <img
                            src="/img/Img8.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                    </figure>

                    <figure>
                        <figcaption>
                            Et enfin, celles sur vos clients et fournisseurs
                            potentiels :
                        </figcaption>
                        <img
                            src="/img/Img9.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                    </figure>

                    <div class="mt-5">
                        <article>
                            <h2>
                                Comptez sur le BPI pour vos études sectorielles
                            </h2>
                            <p>
                                Parmi les avantages exceptionnels que vous offre
                                la plateforme BPI, est celui de vous offrir une
                                étude de marché/sectorielle sur mesure selon
                                votre secteur d’activité. La plateforme BPI vous
                                offre des informations précises sur la taille et
                                l’évolution du marché dans le Région de
                                Marrakech-Safi, la santé financière des entreprises
                                de la région, les principaux acteurs et parts de
                                marché, ainsi que l’analyse concurrentielle de
                                votre secteur :
                            </p>
                            <figure>
                                <img
                                    src="/img/Img10.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />
                                <figcaption>
                                    Cliquer sur suivant, pour parcourir les
                                    étapes suivantes, aucune saisie n’est
                                    nécessaire :
                                </figcaption>
                                <img
                                    src="/img/Img11.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img12.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img13.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                            
                                <img
                                    src="/img/Img15.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />
                            </figure>
                        </article>
                    </div>

                  <figure>
                          <figcaption>
                            La seule rubrique que vous aurez à saisir pour avoir
                            une étude de marché complète et conforme aux
                            standards d’élaboration des business plan, est celle
                            de vos moyens commerciaux. Ci-dessous informations
                            que vous aurez à saisir :
                        </figcaption>

                        <img
                            src="/img/Img16.png"
                            alt="Trulli"
                            style="width:100%"
                        /> 
                        <img
                            src="/img/Img17.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                    </figure>

                    <div class="mt-5">
                        <article>
                            <h2>
                                Entrer les informations relatives à votre étude
                                technique
                            </h2>
                            <p>
                                La saisie relative à l’étude technique s’étale
                                sur 3 parties : « Moyens fonciers et immeubles
                                », « Moyens d’exploitation » et enfin « Moyens
                                humains ». Ci-dessous les écrans des différentes
                                étapes avec une explication pour chacun des
                                écrans :
                            </p>

                            <figure>
                                <img
                                    src="/img/Img18.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img19.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img20.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img21.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />
                                <img
                                    src="/img/Img22.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                              <img
                                    src="/img/Img23.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img24.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />
                            </figure>
                        </article>
                    </div>

                    <figure>
                        <figcaption>
                            Et enfin, les moyens humains nécessaires à votre
                            projet :
                        </figcaption>

                        <img
                            src="/img/Img25.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                        <img
                            src="/img/Img26.png"
                            alt="Trulli"
                            style="width:100%"
                        />
                    </figure>

                    <div class="mt-5">
                        <article>
                            <h2>
                                Saisissez les informations financières de votre
                                projet
                            </h2>
                            <p>
                                Les informations financières sont à saisir en
                                cinq petites étapes : « Programme
                                d’investissement et plan de financement », «
                                Chiffre d’affire prévisionnel », « Achats
                                prévisionnels », « Autres charges externes » et
                                enfin « Charges du personnel ». Ci-dessous les
                                informations détaillées sur les écrans de
                                chacune des étapes :
                            </p>
                            <figure>
                                <img
                                    src="/img/Img27.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img28.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img29.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img30.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img31.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <figcaption>
                                    <b>NB :</b> Pour les
                                    <b>impôts et taxes</b> dans la rubrique «
                                    Autres charges externes », les impôts et
                                    taxes sont à saisir manuellement, un tag
                                    spécifique à été résérvé pour la saisie de
                                    cette information. Nous vous invitons à vous
                                    renseigner sur la valeur de votre taxe
                                    professionnelle et votre impôt sur le revenu
                                    si il est applicable. La taxe de services
                                    communaux est calculée automatiquement par
                                    l’outil. Il y a également un tag « Autres
                                    taxes » si votre activité est suceptibles à
                                    d’autres taxes.
                                </figcaption>

                                <img
                                    src="/img/Img32.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />

                                <img
                                    src="/img/Img33.png"
                                    alt="Trulli"
                                    style="width:100%"
                                />
                            </figure>
                        </article>
                    </div>

                    <div class="mt-5">
                        <article id="verticalImages">
                            <h2>
                                Vous pouvez modifier votre saisie en cours de
                                création du BPI ou après validation via le menu
                                de l’application
                            </h2>
                            <p>
                                Vous pouvez à chaque instant modifier votre
                                saisie, en accèdant à l’étape que vous voulez
                                via le menu de navigation à gauche de votre
                                écran :
                            </p>

                            <div class="row d-flex justify-content-center">
                                <div class="col-md-3 col-sm-3 col-8 col-xl-3">
                                    <img
                                        src="/img/Img38.png"
                                        alt="Trulli"
                                        style="width:100%"
                                    />
                                </div>
                            </div>
                        </article>
                    </div>

                    <div class="mt-5">
                        <article>
                            <h2>
                                En quelques clics vous pouvez récupérer votre
                                business plan chez votre consultant CRIms
                            </h2>
                            <p>
                                Après validation finale de votre saisie muni de
                                votre CIN vous pouvez récupérer votre business
                                plan chez votre conseiller CRIms. Votre
                                conseiller CRIms aura pour mission de vous donner
                                des conseils sur la rentabilité de votre projet
                                et de vous guider pour réaliser des
                                modifications de votre saisie, avant de vous
                                offrir votre business plan complet et prêt à
                                l’emploi.
                            </p>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <!-- //container  -->
</template>

<script>
export default {};
</script>
<style scoped src="../assets/styles/bootstrap.min.css" />

<style scoped>
#header1 {
    background: #526fca;
    padding: 30px;
    color: white;
}

#header1 > h1 {
    font-size: 3em;
}

#header1 > h6 {
    font-size: 1.5em;
}

article {
    margin: 40px 0 0 0;
}

article > h2,
section h2 {
    display: inline-block;
    border-bottom: 5px solid #526fca;
    padding: 0 0 10px 0;
}

article > ul {
    list-style-type: square;
    padding: 20px 20px 0px 50px;
}

figure {
    margin-top: 70px;
}

figcaption {
    font-size: 1.3em;
    margin: 0 0 10px 0;
}

figure > img {
    margin: 0 0 50px 0;
}

figure:first-child {
    margin: 20px 0 0 0;
}

section > .row > div > div > figure {
    margin: 30px 0 0 0;
}
</style>
